import { CopyGridCells } from '../index'
import { Selection } from '../grid-selection'
import { enableCopyMultipleFeature } from '../utils'
function noop () {}

export function canvasTableCellsCopyPlugin (canvasTableInstance) {
  const flag = enableCopyMultipleFeature()
  if (!flag) {
    return {
      lifeCycleHooks: noop,
      paintCanvasCopyCellRect: noop
    }
  }
  const getUniquKey = (r, c) => r + '_' + c
  canvasTableInstance._copySelection = new Selection()
  // 数据发生变化时，清掉状态
  canvasTableInstance.$watch('data', () => {
    canvasTableInstance._copySelection && canvasTableInstance._copySelection.clear()
    canvasTableInstance._copyCellMap = {}
  })
  const lifeCycleHooks = () => {
    canvasTableInstance.$on('hook:mounted', () => {
      canvasTableInstance._copyGridCellsInstance = new CopyGridCells({
        node: canvasTableInstance.$el,
        selection: canvasTableInstance._copySelection,
        handleMouseDownEventCb: (e, copyGridCellsInstance) => {
          // 这里的操作和 canvas的dealClick一样，拿当前点击的单元格的数据
          const { ratio, flatData, boxPosition, headerHeight } = canvasTableInstance
          if (!flatData.length) {
            return
          }
          const y = e.clientY - boxPosition.top
          const x = e.clientX - boxPosition.left
          if (y > headerHeight) {
            const { row, col } = canvasTableInstance.getRowAndCol(x, y, x <= canvasTableInstance.fixedLeftWidth / ratio)
            const { column } = canvasTableInstance.getOriginData(col, row)
            const { _index: columnIndex } = col
            const { index: rowIndex } = row
            const flatRow = flatData[rowIndex]
            if (!canvasTableInstance._copyCellMap) {
              canvasTableInstance._copyCellMap = {}
            }
            const k = getUniquKey(rowIndex, columnIndex)
            const val = flatRow[column.key]

            // 开始记录已选数据，做增加和删除操作
            const currentCellInfo = {
              val: column._showButton ? (column.button || val) : val,
              rowIndex,
              columnIndex
            }
            if (canvasTableInstance._copyCellMap[k]) {
              delete canvasTableInstance._copyCellMap[k]
              copyGridCellsInstance.deleteSelection(currentCellInfo)
              return
            }
            copyGridCellsInstance.addSelection(currentCellInfo)
            canvasTableInstance._copyCellMap[k] = currentCellInfo
          }
        },
        clear () {
          canvasTableInstance._copyCellMap = {}
          canvasTableInstance && typeof canvasTableInstance.paint === 'function' && canvasTableInstance.paint()
        },
        beforeCopy (copyGridCellsInstance) {
          const isCross = copyGridCellsInstance.isGridCross()
          if (isCross) {
            canvasTableInstance.$message.warning('只能复制同行或者同列区域内容')
            return false
          } else {
            return true
          }
        }
      })
    })
    canvasTableInstance.$on('hook:activated', () => {
      canvasTableInstance._copyGridCellsInstance.init()
    })
    canvasTableInstance.$on('hook:deactivated', () => {
      // console.log('-------hook:beforeDestroy')
      canvasTableInstance._copyGridCellsInstance.clearEvent()
    })
    canvasTableInstance.$on('hook:beforeDestroy', () => {
      // console.log('-------hook:beforeDestroy')
      canvasTableInstance._copyGridCellsInstance.clearEvent()
    })
  }

  const init = () => {
    lifeCycleHooks()
  }

  const paintCanvasCopyCellRect = (layerCtx, {
    x,
    y,
    disx,
    disy,
    col,
    row,
    drow,
    text,
    canvasTable
  }) => {
    const { _index: columnIndex } = col
    const { index: rowIndex } = drow
    const k = getUniquKey(rowIndex, columnIndex)
    if (canvasTableInstance._copyCellMap && canvasTableInstance._copyCellMap[k]) {
      // 保存当前画布状态
      layerCtx.save()
      // 设置透明度
      layerCtx.globalAlpha = 0.5 // 设置透明度为50%
      // 绘制矩形
      layerCtx.fillStyle = '#409eff'
      layerCtx.fillRect(x - 6, y - canvasTable.rowH / 2, col.width, 28)
      // 恢复之前保存的画布状态
      layerCtx.restore()
    }
  }
  init()
  return {
    lifeCycleHooks,
    paintCanvasCopyCellRect
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/copy-cells/set-cell-style/canvas.js